import fillProductKey from './middlewares/fillProductKey'
import populate from './middlewares/populate'
import productsA from './ui/productsA'

module.exports = {
  model: 'products',
  name: 'A-鏡框資料',
  ui: productsA,
  middlewares: [populate, fillProductKey],
}



// WEBPACK FOOTER //
// ./src/views/productsA.js